"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Exit = function Exit(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react2["default"].createElement("path", {
    className: "fill",
    d: "M0 11h1.5v2.867c0 .294.224.533.5.533h12c.276 0 .5-.239.5-.533V2.133c0-.294-.224-.533-.5-.533H2c-.276 0-.5.239-.5.533V5H0V2.133C0 .955.895 0 2 0h12c1.105 0 2 .955 2 2.133v11.734C16 15.045 15.105 16 14 16H2c-1.105 0-2-.955-2-2.133V11z"
  }), _react2["default"].createElement("rect", {
    className: "fill",
    width: 10,
    height: 2,
    y: 7,
    rx: 1
  }), _react2["default"].createElement("path", {
    className: "stroke",
    d: "M6 4l4 4-4 4"
  })));
};

exports["default"] = Exit;